export const settingAccommodation = {
    p1: `Informazioni di base`,
    p2: `Inserisci il nome e il logo che gli utenti vedranno quando iniziano il processo di check-in. Se non hai un logo, verrà utilizzato il logo predefinito di WACheckin.`,
    p3: `Politiche dell'alloggio`,
    p4: `Personalizza le politiche del tuo alloggio. Queste saranno le condizioni che gli ospiti accetteranno al momento del check-in.`,
    p5: `SPAGNOLO`,
    p6: `INGLESE`,
    p7: `Messaggio di benvenuto`,
    p8: `Personalizza il messaggio di benvenuto che i tuoi ospiti vedranno dopo aver completato il check-in.`,
    p9: `Chiavi delle stanze`,
    p10: `Registra e gestisci le stanze dotate di serrature intelligenti. Configura i codici di accesso che verranno forniti agli ospiti dopo il check-in per agevolare il loro ingresso.`,
    p11: `Autorità competenti`,
    p12: `Configura la connessione con le autorità locali per l'invio automatico delle comunicazioni dei viaggiatori. Inserisci il nome utente e la password corrispondenti alla piattaforma di ciascuna autorità competente.`,
    p13: `Guardia Civil`,
    p14: `Policía Nacional`,
    p15: `Ertzaintza`,
    p16: `Mossos`,
    p17: `dati di accesso`,
    p18: `L'ente è obbligatorio`,
    p19: `Il nome utente è obbligatorio`,
    p20: `La password è obbligatoria`,
    p21: `Errore durante il tentativo di convalida dei dati`,
    p22: `L'ente è obbligatorio`,
    p23: `Il nome utente è obbligatorio`,
    p24: `La password è obbligatoria`,
    p25: `Dati aggiornati con successo`,
    p26: `Errore durante l'inserimento dei dati della polizia dell'immigrazione`,
    p27: `Scarica il codice QR del tuo alloggio per check-in rapidi e ottieni il link da inviare direttamente agli ospiti.`,
    p28: `Modifica il codice di sicurezza dell'alloggio`,
    p29: `Verifichiamo l'identità degli ospiti confrontando la foto del loro documento o passaporto con un selfie in tempo reale.`,
    p30: `Abilitando questa opzione, gli ospiti dovranno verificare la propria identità durante il processo di check-in. Se la convalida non viene completata con successo, non potranno proseguire con il check-in.`,
    p31: `Errore durante l'attivazione della verifica dell'identità`,
    p32: `Impostazioni di pagamento`,
    p33: `Addebita gli ospiti durante il processo di check-in, consentendo loro di pagare servizi aggiuntivi e le tariffe applicabili.`,
    p34: `Codice di sicurezza dell'alloggio`,
    p35: `Alloggio`,
    p36: `Abilita questa opzione per inviare automaticamente un messaggio WhatsApp il giorno del check-out, chiedendo agli ospiti di valutare la loro esperienza presso l'alloggio da 1 a 5.`,
    p37: `Inserisci l'URL del sito di recensioni che vuoi configurare affinché i tuoi ospiti lascino le loro opinioni, che sia su Google o su un altro sito di recensioni che utilizzi. Questo aiuta a migliorare la visibilità e la reputazione dell'alloggio.`,
    p38: `Inserisci l'URL del sito di recensioni (es. Google, TripAdvisor)`,
    p39: `Gestisci il tuo alloggio`,
    p40: `Informazioni di base`,
    p41: `Politiche dell'alloggio`,
    p42: `Messaggio di benvenuto`,
    p43: `QR dell'alloggio`,
    p44: `Pagamenti degli ospiti`,
    p45: `Carica il logo dell'alloggio`,
    p46: `Puoi caricare o trascinare un'immagine nel riquadro`,
    p47: `Design`,
    p48: `Politiche`,
    p49: `Benvenuto`,
    p50: `Regione`,
    p51: `Spagnolo`,
    p52: `Inglese`,
    p53: `Arabo`,
    p54:``,
    p55:``,
    p56:``,
    p57:``,
    p58:``,
    p59:``,
    p60:``,
    p61:``,
    p62:``,
    p63:``,
    p64:``,
    p65:``,
    p66:``,
    p67:``,
    p68:``,
    p69:``,
    p70:``,
};
